import React from 'react'
import { Container, Loader, SortableTable } from 'components/UIElements'
import STRINGS from 'utils/strings'

const ParticipantHistory = ({ ptpHistoryLoading, participantHistory }) => {
  const headerOptions = [
    { key: 'name', sortable: true, component: 'Action' },
    {
      key: 'timestamp',
      sortable: true,
      component: 'Timestamp',
    },
  ]
  const hasHistory = participantHistory.length > 0

  return (
    <Container className={`ptp-instruments ${hasHistory ? 'fixed-min-height' : ''}`}>
      <div className='title'>{STRINGS.history}</div>
      {ptpHistoryLoading ? (
        <Loader inContainer />
      ) : (
        <>
          {hasHistory ? (
            <SortableTable sortingBy='name' headerOptions={headerOptions} rowList={participantHistory} />
          ) : (
            <p>{'There are no historical details for this participant'}</p>
          )}
        </>
      )}
    </Container>
  )
}

export default ParticipantHistory
